import Component from'./component';export default Component;